// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"781":"b7057e7e","885":"4d13433e","889":"0f240882"}[chunkId] + ".chunk.js";
};